<template>
  <div class="relative w-full h-screen flex items-center justify-center py-10">
    <!-- Background Image -->
    <div class="absolute inset-0 w-full h-full">
      <img
        src="@/../img/home/all-doctors.jpg"
        alt="Background"
        class="w-full h-full object-cover rounded-lg shadow-lg"
      />
      <!-- Dark Overlay -->
      <div class="absolute inset-0 bg-white bg-opacity-80"></div>
    </div>

    <!-- Content Wrapper -->
    <div class="relative z-10 flex flex-col items-center text-center w-full px-4 md:px-8">
      <!-- Main Title (Centered on Mobile) -->
      <h1
        class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6 max-w-3xl"
      >{{ $t('Onze kernwaarden: flexibiliteit, professionaliteit, kwaliteit') }}</h1>

      <!-- Grid Layout for Core Values -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl">
        <!-- Flexibility -->
        <div class="text-center">
          <Icon :icon="heart" class="w-16 sm:w-14 mx-auto mb-4" />
          <h3 class="text-xl sm:text-2xl font-semibold">{{ $t('Flexibiliteit') }}</h3>
          <p class="mt-2 text-base sm:text-lg">
            Zorgblik benadrukt de noodzaak van maatwerkoplossingen en aanpasbaarheid in het bieden van zorg en ondersteuning.
            <br />• Flexibele inzet van zorgpersoneel (uitzend, zzp, team/individueel).
            <br />• Focus op korte- en langetermijnoplossingen.
            <br />• Samenwerking met zorginstellingen voor afgestemde oplossingen.
          </p>
        </div>

        <!-- Professionalism -->
        <div class="text-center">
          <Icon :icon="star" class="w-16 sm:w-14 mx-auto mb-4" />
          <h3 class="text-xl sm:text-2xl font-semibold">{{ $t('Professionaliteit') }}</h3>
          <p class="mt-2 text-base sm:text-lg">
            De kern van Zorgblik’s dienstverlening is de inzet van hooggekwalificeerde zorgprofessionals die bijdragen aan de verbetering van zorg.
            <br />• Ervaren professionals op diverse niveaus en opdrachten.
            <br />• Zorgblik Academy: training, coaching en opleiding.
            <br />• Probleemanalyse als basis voor duurzame verbeteringen.
          </p>
        </div>

        <!-- Quality -->
        <div class="text-center">
          <Icon :icon="light" class="w-16 sm:w-14 mx-auto mb-4" />
          <h3 class="text-xl sm:text-2xl font-semibold">{{ $t('Kwaliteit') }}</h3>
          <p class="mt-2 text-base sm:text-lg">
            Zorgblik onderscheidt zich door een toekomstgerichte aanpak in een complexe zorgsector.
            <br />• Creatieve en vernieuwende oplossingen, ondanks uitdagingen.
            <br />• Samenwerking met onderwijsinstellingen voor talentontwikkeling.
            <br />• Structurele verbeteringen naast uitvoerende diensten.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>